// @ts-expect-error untyped module
import { getSignUpUrl } from '../../utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ResultsCallout({
  signUpUrl
}) {
  return /*#__PURE__*/_jsx(CardWrapper, {
    compact: true,
    marginBlockStart: "500",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "center",
      padding: "1000",
      gap: "1000",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "target",
        height: 100
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "500",
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsxs(View, {
          maxInlineSize: "420px",
          children: [/*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.storefront.results.callout.title"
            })
          }), /*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.storefront.results.callout.description"
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          external: true,
          href: signUpUrl || getSignUpUrl(),
          truncate: false,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.storefront.results.callout.button"
          })
        })]
      })]
    })
  });
}